// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"649b1c8e","253":"7a875f06","370":"1972c73a","391":"aa57cf13","453":"09b6c348","454":"de023083","482":"ba3a2c50","571":"5dd5b40d","599":"0cb16522","800":"586eb0ac","853":"2a33f982","854":"7a1dc16e","876":"424e1217","900":"7132d90a"}[chunkId] + ".chunk.js";
};